module.exports = __webpack_public_path__ + "static/media/csgo.7589f81f.jpg";